import React from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

const COLORS = ['#1D4ED8', '#FF0000', '#000000'];

// Función para formatear los valores en USD
const formatUSD = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value);
};

const CustomPieChart = () => {
  const { t } = useTranslation();

  const data = [
    { name: t('inserted'), value: 349467276.59 },
    { name: t('removed'), value: 257976201.55 },
    { name: t('exceed_amount'), value: 91491075.04 },
  ];

  return (
    <div className="w-full mx-auto p-4 bg-white shadow-lg rounded-lg my-4">
      <h2 className="text-xl font-bold text-gray-800 text-center">{t('where_is_money')}</h2>
      <p>
        {t('where_is_money_info')}
      </p>

      <div className='flex justify-center'>
        <PieChart width={700} height={350}>
          <Pie
            data={data}
            cx={300}
            cy={150}
            labelLine={false}
            label={({ name, value }) => `${name}: ${formatUSD(value)}`} // Mostrar el valor en USD
            outerRadius={90} // Aumentar el radio para más espacio
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => formatUSD(value)} /> {/* Formatear el tooltip en USD */}
          <Legend layout="centric" />
        </PieChart>
      </div>
    </div>
  );
};

export default CustomPieChart;